import React, { useEffect, useState } from "react";
import CardsGrid from "../../Components/CardsGrid";
import Footer from "../../Components/Footer";
import Navbar from "../../Components/Header";
import Pricing from "../../Components/PricingTable";
import bgplans from "../../Images/Frame.png";
import vidTop from "../../Images/Graphics PNG/vid2.png";
import grading from "../../Images/Video Editing Icons/Color grading.png";
import manip from "../../Images/Video Editing Icons/Color manipulation.png";
import data from "../../Images/Video Editing Icons/Data visulization.png";
import engaging from "../../Images/Video Editing Icons/Enagaging subtitles.png";
import edit from "../../Images/Video Editing Icons/Green screen editing.png";
import info from "../../Images/Video Editing Icons/Info Graphics.png";
import long from "../../Images/Video Editing Icons/long videos.png";
import motion from "../../Images/Video Editing Icons/Motion Graphics.png";
import Realistic from "../../Images/Video Editing Icons/Realistic AI Voiceover.png";
import reels from "../../Images/Video Editing Icons/Reel.png";
import roto from "../../Images/Video Editing Icons/Rotoscoping.png";
import smooth from "../../Images/Video Editing Icons/Smooth and seamless transitions.png";
import sound from "../../Images/Video Editing Icons/Sound Design.png";
import icons from "../../Images/Video Editing Icons/Text icons  animations.png";

const VideoEditingService = () => {
  const [currentWord, setCurrentWord] = useState(0); // Start with the first word
  const [animate, setAnimate] = useState(false); // For triggering animation
  const words = ["Unique", "High-Quality", "Specialized", "Exclusive"];
  const cardsData = [
    {
      title: "Reels",
      description:
        "Create short, engaging video reels for social media platforms.",
      Icon: reels,
    },
    {
      title: "Long Form Videos",
      description:
        "Produce long-form content for platforms like YouTube and more.",
      Icon: long,
    },
    {
      title: "Realistic AI Voiceovers",
      description: "Generate realistic AI voiceovers for your videos.",
      Icon: Realistic,
    },
    {
      title: "Smooth and Seamless Transitions",
      description: "Create smooth transitions between video scenes.",
      Icon: smooth,
    },
    {
      title: "Text, Icons, Animations Behind Subject",
      description:
        "Add text, icons, and animations behind the subject without a green screen.",
      Icon: icons,
    },
    {
      title: "Engaging Subtitles",
      description:
        "Add engaging subtitles to videos for accessibility and impact.",
      Icon: engaging,
    },
    {
      title: "Motion Graphics",
      description: "Incorporate motion graphics to enhance your videos.",
      Icon: motion,
    },
    {
      title: "Sound Design",
      description: "Design immersive soundscapes for your videos.",
      Icon: sound,
    },
    {
      title: "Infographics",
      description:
        "Visualize data effectively through infographics in your videos.",
      Icon: info,
    },
    {
      title: "Data Visualization",
      description: "Create visual representations of data within your videos.",
      Icon: data,
    },
    {
      title: "Green Screen Editing",
      description: "Use green screen to add custom backgrounds to your videos.",
      Icon: edit,
    },
    {
      title: "Color Grading and Correction",
      description:
        "Enhance your videos with professional color grading and correction.",
      Icon: grading,
    },
    {
      title: "Color Manipulation",
      description: "Manipulate video colors for a specific mood or theme.",
      Icon: manip,
    },
    {
      title: "Rotoscoping",
      description:
        "Use rotoscoping to isolate subjects from backgrounds in videos.",
      Icon: roto,
    },
  ];

  const plans = [
    {
      name: "Basic",
      description:
        "A perfect starter package for creating engaging video content with essential elements.",
      features: [
        "Engaging Reels with 1 revision on script",
        "Viral Subtitles that help retain the user's attention",
        "Smooth transitions",
        "B-Roll Footage to help tell the story and create a more engaging video",
      ],
    },
    {
      name: "Standard",
      description:
        "Enhance your video content with more detailed revisions and custom transitions.",
      features: [
        "Engaging Reels with 2-3 revisions on script",
        "Viral Subtitles that help retain the user's attention",
        "Smooth and custom transitions (animated transitions and more seamless ideas)",
        "B-Roll Footage to help tell the story and create a more engaging video",
        "Long Form Video longer than 5 minutes, up to an hour",
      ],
      popular: true, // Optional if this is the most popular plan
    },
    {
      name: "Premium",
      description:
        "Complete video editing solutions with unlimited revisions and advanced features.",
      features: [
        "Engaging Reels with unlimited revisions",
        "Viral Subtitles that help retain the user's attention",
        "Smooth and custom transitions (animated transitions and more seamless ideas)",
        "B-Roll Footage to help tell the story and create a more engaging video",
        "Long Form Video longer than 5 minutes, up to an hour",
        "Motion Graphics with interactive and visually pleasing animations to instantly hook the user (e.g., Magnates Media)",
        "Vector animations for explainer videos (e.g., Iman Gadzhi)",
      ],
    },
  ];

  useEffect(() => {
    // Change word every second
    const interval = setInterval(() => {
      setAnimate(true); // Trigger the animation

      setTimeout(() => {
        setCurrentWord((prevWord) => (prevWord + 1) % words.length); // Change the word
        setAnimate(false); // Reset the animation
      }, 500); // Duration of the animation (0.5s)
    }, 1000); // Change word every second

    return () => clearInterval(interval); // Clean up the interval on component unmount
  }, []);

  return (
    <div className="mb-4">
      <div className="flex flex-col justify-between ">
        <div className="">
          <Navbar color={"bg-teal-950 text-white"} />
        </div>
        <div className=" max-w-7xl mx-auto px-4  lg:px-6 flex flex-col md:flex-row lg:flex-row gap-8 pb-20 lg:pt-12">
          {/* Left Side: Text Section */}
          <div className="flex flex-col justify-center w-full lg:w-1/3 md:w-1/3 mt-6 md:mt-6 lg:mt-10 px-8  lg:px-6 ">
            <h1 className="relative h-12 mb-2 md:mb-4 lg:mb-4">
              {/* Animated word */}
              <span
                className={`absolute transition-transform duration-500 ease-in-out  text-2xl md:text-3xl lg:text-4xl font-bold text-teal-500`}
              >
                {words[currentWord]}
              </span>
            </h1>

            <h2 className="text-teal-800 text-4xl md:text-5xl lg:text-6xl font-bold mb-6 ">
              Video Editing Services
            </h2>
            <p className="lg:flex md:flex hidden text-gray-600 mb-8 text-md md:text-lg lg:text-lg">
              Ignite the force of visual storytelling, from bespoke
              illustrations to captivating infographics
            </p>
            <p className="sm:flex lg:hidden md:hidden text-gray-600 mb-8 text-md md:text-lg lg:text-lg">
              Ignite the force of visual storytelling, from bespoke
              illustrations to captivating infographics, our talented artists
              sculpt mesmerizing designs that deeply connect with your audience
              and amplify your brand's message.
            </p>
       
          </div>
          {/* Right Side: Image Section */}
          <div className="hidden md:flex lg:flex flex-col lg:flex-row md:flex-row justify-center items-center lg:justify-end w-full lg:w-2/3 md:w-2/3 mt-10 md:mt-0 lg:mt-0 xl:mt-0">
            <img
              src={vidTop}
              alt="Illustration Design"
              className="w-[400px] h-[250px] md:w-[450px] md:h-[400px] lg:w-[800px] lg:h-[500px]"
            />
          </div>
        </div>

        {/* Services Section */}
        <CardsGrid
          cardsData={cardsData}
          heading={"Creative Video Editing Solutions"}
        />

        {/* Pricing Section */}
        <div
          className="w-full mx-auto"
          style={{
            backgroundImage: `url(${bgplans})`,
            backgroundSize: "cover",
            backgroundPosition: "top left",
            backgroundRepeat: "no-repeat",
            backgroundAttachment: "fixed", // Fix background movement
          }}
        >
          <Pricing plans={plans} />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default VideoEditingService;
